import React from 'react';
import { Link } from 'react-router-dom';
import './EventCard.css';
import cardCombined from '../images/HomePage_eventCard.svg';

const EventCard = ({ image, date, title, description, actionUrl, actionLabel = 'Sign Up!', signUpUrl }) => {
  const destination = actionUrl || signUpUrl || '/';
  const isInternalRoute = destination.startsWith('/') && !destination.startsWith('//');

  return (
    <div className="event-card">
      <img src={cardCombined} className="card-combined" alt="card base" />

      <div className="card-content">
        <div className='empty-space'></div>
        <div className="card-image">
          <div className="image-frame">
            <img src={image} alt={title} />
          </div>
        </div>

        <div className="event-info">
          <div className="card-header">
            <h3 className="event-title">{title}</h3>
            <div className="event-date">{date}</div>
          </div>

          <p className="event-desc">{description}</p>

          <div className="card-actions">
            {isInternalRoute ? (
              <Link to={destination} className="sign-up">{actionLabel}</Link>
            ) : (
              <a href={destination} className="sign-up">{actionLabel}</a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventCard;
